import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'tiMemoize',
})
export class MemoizePipe implements PipeTransform {
  transform(fn: Function, ...args: any[]): any {
    return fn(...args);
  }
}
